































	import { MyActions } from '@/models/Store/State';
import { getURL } from '@/utils/misc';
	import Vue from 'vue';
    import _preview from '../../services/endpoints/preview';

    export default Vue.extend({
        name: "ShareDialogComp",
        data: () => ({
            switched: false,
            copied: false,
        }),
        computed: {
            termin: function(): any {
                return this.$vStore.getters.termin;
            },
            switchValue: {
                get: function(): boolean {
                    return this.switched;
                },
                set: async function(value: boolean): Promise<void> {
                    this.switched = value;
                    await _preview.setPreviewable(this.termin.id, value);
                }
            },
            open: {
                get: function(): boolean {
                    return this.$vStore.getters.isDialogOpen('share');
                },
                set: function(): void {
                    this.$vStore.dispatch(MyActions.CloseDialog);
                }
            },
            previewLink: function(): string {
				return getURL() + `preview/${this.termin.id}`;
            }
        },
        created: async function(): Promise<void> {
            this.switched = await _preview.getPreviewable(this.termin.id);
        },
        methods: {
            copyLink: async function(): Promise<void> {
                await navigator.clipboard.writeText(this.previewLink);
                this.switchValue = true;
                this.copied = true;
            }
        }
    })
